import {FullInfoUser} from "../../types/api/authorization/user.types";
import {useFetch} from "../useFetch";
import {userService} from "../../services/authorization/user-service";

export const useFetchAllFullInfoUser = () => {
    const { isLoading, error, data, refetch } = useFetch<FullInfoUser[]>(userService.getAllFullInfoUser);

    return { data: data || [], isLoading, error, refetch };
}